import type Phaser from 'phaser';
import { getSceneRouter } from './SceneRouter.js';
import { UiKit } from './UiKit.js';
import { WORLD_BACK_BUTTON_LAYOUT } from './worldBackLayout.js';

/** Wspólny, nazwany powrót z wnętrz do Town. */
export function worldBackButton(scene: Phaser.Scene): Phaser.GameObjects.Container {
  const button = UiKit.button(scene, {
    ...WORLD_BACK_BUTTON_LAYOUT,
    label: '← Miasteczko',
    fill: 0xb8e6d0,
    name: 'back-to-town',
    onClick: () => getSceneRouter().go('Town'),
  });
  button.setScrollFactor(0);
  button.setDepth(20_100);
  button.setData('navTarget', 'Town');
  return button;
}
